import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this._handleTabsChange = (event) => this.onTabsChange(event)
    this.element.addEventListener("tabs:change", this._handleTabsChange)
  }

  disconnect() {
    this.element.removeEventListener("tabs:change", this._handleTabsChange)
  }

  openChat(event) {
    event?.preventDefault?.()

    this.dispatchOpenEvent()

    const host = document.querySelector('[data-controller~="chat-widget"]')
    const controller = host ? this.application.getControllerForElementAndIdentifier(host, "chat-widget") : null
    if (controller?.isOpen?.()) return

    const launcher = document.querySelector('[data-action~="click->chat-widget#open"]')
    if (launcher) {
      launcher.click()
      return
    }

    controller?.open()
  }

  dispatchOpenEvent() {
    try {
      window.dispatchEvent(new CustomEvent("chat-widget:open", { detail: { source: "just-ask" } }))
    } catch (_) {}
  }

  onTabsChange(event) {
    const name = event.detail?.name
    if (!name) return
    if (name === "live-chat") this.openChat()
  }
}
